import { useEffect, useState } from 'react';
import { API } from '@/App';

/**
 * Fetches the current user's Pollen Dots capabilities once per session.
 * Caches the result via module-level memoization (cleared on manual reload).
 */
let _cache = null;
let _inflight = null;

const authHeaders = () => {
  const t = localStorage.getItem('session_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const fetchCapabilities = async () => {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = (async () => {
    try {
      const res = await fetch(`${API}/pollen/me/capabilities`, { credentials: 'include', headers: authHeaders() });
      if (res.ok) { _cache = await res.json(); return _cache; }
    } catch { /* noop */ }
    return { role: '', is_super_admin: false, can_view_profits: false, can_view_pnl: false, can_view_referral_profits: false, can_view_prices: false, can_manage_users: false };
  })();
  return _inflight;
};

export const usePollenCapabilities = () => {
  const [caps, setCaps] = useState(_cache || {
    role: '', is_super_admin: false, can_view_profits: false, can_view_pnl: false,
    can_view_referral_profits: false, can_view_prices: false, can_manage_users: false,
  });
  const [loaded, setLoaded] = useState(Boolean(_cache));
  useEffect(() => {
    if (_cache) { setCaps(_cache); setLoaded(true); return; }
    fetchCapabilities().then(c => { setCaps(c); setLoaded(true); });
  }, []);
  return { ...caps, loaded };
};
